export default {
	AnalysisReportData: {},
	LatestAnalysisReportHistory: {},
	LastRequestFilter: {}
};
